module.exports = __webpack_public_path__ + "img/icon_attpoint.e54e9a71.svg";